import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import styles from '../../css/admin/Navbar.module.css';
import { useLanguage } from '../../hooks/LanguageContext'; // Import useLanguage hook
import { isApp } from '../../utils/isApp'; // [APP-FORK]
import translations from '../admin/translations'; // Import translations

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { storeNo } = useParams();
  const { language } = useLanguage(); // Only use language state
  const [, setIsAdminPage] = useState();

  const isActive = path => {
    return location.pathname === path;
  };

  useEffect(() => {
    setIsAdminPage(location.pathname.startsWith('/admin'));
  }, [location]);

  const renderNavBar = () => {
    const t = translations[language];

    // [APP-FORK] '홈' 목적지 — 웹/앱 분기. 목적지가 원래 verification 인 건 의도다:
    //   40fac1b 가 이 항목을 t.giftVerification('기프트 검증') 라벨로 만들었고,
    //   2844d7e 가 첫 탭으로 올리면서 라벨만 t.home 으로 바꿨다(목적지는 그대로).
    //   웹 상점주에겐 웹캠 QR 스캐너가 주 작업화면 = 홈 → 웹은 건드리지 않는다.
    //   ★같은 번들을 앱 웹뷰와 웹 상점주가 함께 쓴다(utils/isApp.js:2-3) → 무조건 변경 금지.
    // 앱은 웹 카메라를 쓰지 않는다(쓸 수 없다):
    //   naegift_mobile_app/lib/webview/web_view_page.dart:119-228 의 InAppWebView 에
    //   onPermissionRequest 핸들러가 없어 flutter_inappwebview 가 getUserMedia 를 무조건 거부한다
    //   (Android flutter_inappwebview_android-1.1.3 InAppWebViewChromeClient.java:1264-1266
    //    defaultBehaviour → request.deny() / iOS flutter_inappwebview_ios-1.1.2
    //    InAppWebView.swift:1696-1701 defaultBehaviour → decisionHandler(.deny))
    //   → Verification.js:126 QrScanner 마운트 → NotAllowedError → Verification.js:86-89 팝업.
    //   앱은 네이티브 스캐너를 쓴다(app_shell.dart:472 _openScanner → scanner/scanner_page.dart,
    //   admin 도 하단 QR 탭을 받는다 — app_shell.dart:1306-1311 _bottomTabBar).
    //   → 앱 '홈'은 상점관리자 홈으로 보낸다. 목적지 근거: naegift_mobile_app/lib/config.dart:97
    //   adminHome(네이티브 헤더 로고 탭과 동일 착지). router.js:91-94 <Navigate to="home" replace />
    //   가 최종적으로 /mobile/giftstatus/{storeNo}/home 으로 리다이렉트한다.
    const homePath = isApp()
      ? `/mobile/giftstatus/${storeNo}`
      : `/mobile/verification/${storeNo}`;

    return (
      <div className={styles.navbar}>
        <div
          onClick={() => navigate(homePath)}
          className={
            isActive(`/mobile/verification/${storeNo}`) ||
            location.pathname.startsWith(`/mobile/verifyconfirm/${storeNo}`) ||
            location.pathname.startsWith(`/mobile/verifysuccess/${storeNo}`) ||
            location.pathname.startsWith(`/mobile/verifyfailure/${storeNo}`)
              ? styles.navItemsSelected
              : styles.navItems
          }
        >
          {t.home}
        </div>
        <div
          onClick={() => navigate(`/mobile/giftstatus/${storeNo}/gift`)}
          className={
            location.pathname === `/mobile/giftstatus/${storeNo}/gift`
              ? styles.navItemsSelected
              : styles.navItems
          }
        >
          {t.giftStatus}
        </div>
        <div
          onClick={() => navigate(`/mobile/giftstatus/${storeNo}/sales`)}
          className={
            location.pathname === `/mobile/giftstatus/${storeNo}/sales` ||
            location.pathname === `/mobile/giftstatus/${storeNo}`
              ? styles.navItemsSelected
              : styles.navItems
          }
        >
          판매현황
        </div>
      </div>
    );
  };

  return renderNavBar();
}
